<template>
  <div class="row">
    <div class="col-md-3">
      <o-card :title="$t('medtastic.configuration')" class="settings-card">
        <ul class="nav flex-column nav-pills">
          <li v-for="tab in tabs" class="nav-item" v-if="hasPermission(tab)">
            <router-link :to="{ name: tab.route }" class="nav-link" active-class="active">
              {{ tab.name }}
            </router-link>
          </li>
        </ul>
      </o-card>
    </div>

    <div class="col-md-9">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
  export default {
    loading: false,

    computed: {
      tabs () {
        return [
          {
            name: this.$t('medtastic.notification_emails'),
            route: 'medtastic.configuration.notification_email_list',
            requiredPermissions: ['POST api/medtastic/notification_emails/{id}']
          }
        ]
      }
    },
    methods: {
      hasPermission(item) {
        let result = true
        if (!('requiredPermissions' in item)) {
          result = true
        }
        let permissions = item.requiredPermissions
        let user = this.$store.getters['auth/user']
        if (!user.is_super_user && permissions) {
          permissions.forEach((permission) => {
            if (!user.routePermissions.includes(permission)) {
              result = false
            }
          })
        }
        return result
      }
    }
  }
</script>

<style>
  .settings-card .card-body {
    padding: 0;
  }
</style>
